import {
    Button,
    Grid,
    InputAdornment,
    makeStyles,
    TextField,
} from "@material-ui/core";
import React, {useState} from "react";
import {useWatch} from "react-hook-form";
import {modal} from "../../../util";
import apiHelper from "../../../util/ApiHelper";
import styled from "styled-components";
import _ from 'lodash';

const A = styled.a`
  color: #306F9D;
  text-decoration: none;
`;

const useStyles = makeStyles({
    fileInput: {
        width: "100%",
        marginBottom: "12px",

        "& .MuiInputLabel-outlined": {
            transform: "translate(14px, 13px)",
        },

        "& .MuiOutlinedInput-adornedEnd": {
            height: "40px",
            paddingRight: "5px",
        },

        "& input": {
            fontSize: "13px",
        },
    },
});

export default function UploadImage(props) {
    const {
        name,
        data,
        control,
        Controller,
        getValues,
        setValue,
        lang = null,
        disabled,
        uploadLabel,
        changeLabel,
        uploadFolder,
        embeddedName
    } = props;

    const alias = lang ? `localizations.${lang}.${name}` : name;

    useWatch({
        control,
        name: alias
    });

    const classes = useStyles();

    const [currImage, setCurrImage] = useState(
        data ? embeddedName ? _.get(data, embeddedName) : lang ? data.localizations[lang][name] : data[name] : ""
    );

    const handleFileUpload = async (e) => {
        try {
            setValue(alias, "loading");
            const file = e.target.files[0];
            if (file) {
                let result;
                if (uploadFolder) {
                    result = await apiHelper.hkiff.uploadHKIFFFile(file, uploadFolder);
                } else {
                    result = await apiHelper.hkiff.uploadHKIFFFile(file);
                }
                const url = result.data.url;
                setValue(alias, url);
                setCurrImage(url);
            }
        } catch (error) {
            console.log(error);
        }
    };

    return (
        <Grid container item xs={12}>
            <TextField
                htmlFor={`raised-button-file-${alias}`}
                className={classes.fileInput}
                value=""
                variant="outlined"
                placeholder={currImage ? changeLabel : uploadLabel}
                fullWidth
                InputProps={{
                    classes: {
                        input: classes["&::placeholder"],
                    },
                    endAdornment: (
                        <Controller
                            control={control}
                            name={alias}
                            defaultValue={data && embeddedName ? _.get(data, embeddedName) : lang ? data.localizations[lang][name] : data[name]}
                            render={({field}) => {
                                return (
                                    <InputAdornment
                                        position="end">
                                        <input
                                            style={{display: "none"}}
                                            id={`raised-button-file-${alias}`}
                                            type="file"
                                            onChange={(e) => {
                                                handleFileUpload(e);
                                            }}
                                        />
                                        <Button
                                            htmlFor={`raised-button-file-${alias}`}
                                            variant="outlined"
                                            component="label"
                                            size="small"
                                        >
                                            Choose
                                        </Button>
                                    </InputAdornment>
                                );
                            }}
                        />
                    ),
                }}
                style={currImage ? {marginBottom: "0"} : {}}
            />

            {getValues(alias) || currImage ? (
                <p>
                    <img
                        src={getValues(alias) || currImage}
                        style={{
                            maxHeight: "30px",
                            maxWidth: "30px",
                            cursor: "pointer"
                        }}
                        alt=""
                        onClick={() => window.open(getValues(alias) || currImage, '_blank').focus()}
                    />
                    &nbsp;
                    <A href={getValues(alias) || currImage}
                       target="_blank">
                        <small>
                            {getValues(alias)
                                ? getValues(alias).split("/").pop()
                                : currImage.split("/").pop()}
                        </small></A>
                    {disabled || (
                        <small
                            style={{
                                marginLeft: "20px",
                                textDecoration: "underline",
                                color: "#962013",
                                cursor: "pointer",
                            }}
                            onClick={async () => {
                                const decision = await modal.fire({
                                    title: "Delete Image",
                                    text: "Are you sure to delete this image?",
                                    showCancelButton: true,
                                    confirmButtonText: `Delete`,
                                });
                                if (decision.isConfirmed) {
                                    setCurrImage("");
                                    setValue(alias, "");
                                }
                            }}
                        >
                            Delete
                        </small>
                    )}
                </p>
            ) : (
                ""
            )}
        </Grid>
    );
}
